// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryNameStyles } from "@steiner/Overrides/Widgets/Category/CategoryName";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

categoryNameStyles.categoryNameWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        row-gap: 20px;
        flex-wrap: wrap;
        width: 100%;
        margin-bottom: 20px;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            margin-bottom: 16px;
        }
    `,
};
categoryNameStyles.categoryName = {
    css: css`
        margin-bottom: 0;
    `,
};
